import http from '../http-commons'

class PostDataService {
  getAll() {
    return http.get("/post");
  }

  getPost(postId) {
		return http.get('/post/search', { params: { id: postId } })
	}
}

export default new PostDataService();